const LOGO_PATH = '/images/logos/logo.svg';
const SMALL_LOGO_PATH = '/images/logos/logo-small.png';
const QR_PDF_HEADER_LOGO_PATH = '/images/logos/qr-pdf-header-logo.svg';
const QR_PDF_FOOTER_LOGO_PATH = '/images/logos/qr-pdf-footer-logo.svg';

export { LOGO_PATH, SMALL_LOGO_PATH, QR_PDF_HEADER_LOGO_PATH, QR_PDF_FOOTER_LOGO_PATH };
